module.exports = __webpack_public_path__ + "img/down-chiv.569bc8ba.svg";